export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_62187982-65b8-4548-8f5d-211c9e77db48/artifacts/5vq6auvv_AIS%20Logo%20x%20Social%20Oro.jpg",

  // NEW — Python leather loafers with gold horsebit, luxury bedroom interior (Slide 1)
  pythonLoafer:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_ais-luxury-footwear/artifacts/sjyvxp4f_hf_20260827_153405_35198722-6a27-4f29-970f-3e0e476230fb.webp",
  // NEW — Brown fringed sabot at sunset villa on marble bench (Slide 2)
  brownSabotSunset:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_ais-luxury-footwear/artifacts/iauutw2f_hf_20260528_142754_3b56ac13-a60e-499e-bb7e-9117e21cfb91.webp",

  // NEW — yellow fringed mocassins at sunset villa (cover hero)
  yellowMocassinsSunset:
    "https://customer-assets.emergentagent.com/job_ais-luxury-footwear/artifacts/q9bkmwsy_hf_20260624_143303_78109336-e29f-4a94-a911-d882dc4068c1.png",
  // NEW — woman on outdoor lounge with yellow fringed mocassins, Dubai skyline
  yellowMocassinsModel:
    "https://customer-assets.emergentagent.com/job_ais-luxury-footwear/artifacts/rnc4id91_hf_20260624_142644_8f9c6b6e-1e49-4981-98f8-409c8e2f07ff%20%282%29.png",
  // NEW — brown classic gommino on marble bar, luxury lounge with gold
  brownGomminoLounge:
    "https://customer-assets.emergentagent.com/job_ais-luxury-footwear/artifacts/5dbzn4it_hf_20260528_130937_74a4ba7d-30eb-4c54-b102-f5d7f8a4a30f%20%281%29.png",

  // Earlier set
  arabianMocassin:
    "https://customer-assets.emergentagent.com/job_ais-luxury-footwear/artifacts/hzv9mv1w_hf_20260528_131032_3ba2af40-83e3-4702-9d6d-c3909addc757.jpg",
  sandalsSunset:
    "https://customer-assets.emergentagent.com/job_ais-luxury-footwear/artifacts/vwdbp4c8_hf_20260528_143012_31c9ce98-47b9-4241-b8f0-c459d6d5c9af.jpg",
};

export const SLIDES = [
  { id: 1, label: "Cover" },
  { id: 2, label: "Positioning" },
  { id: 3, label: "Brand World" },
  { id: 4, label: "Customer" },
  { id: 5, label: "Hero" },
  { id: 6, label: "Materials" },
  { id: 7, label: "Why GCC" },
  { id: 8, label: "Opportunity" },
  { id: 9, label: "Pricing" },
  { id: 10, label: "Contact" },
];
